import React from 'react';
import RemoveEntryLabel from './RemoveEntryLabel';

const RemoveFlightLabel = ({
  flight: { id, airportDestination, airportOrigin },
  handleRemoveFlight
}) => (
  <RemoveEntryLabel
    handleRemove={handleRemoveFlight}
    id={id}
    question={`Remove flight ${(airportOrigin.name ||
      airportOrigin.iata ||
      airportOrigin) + ' -> '}  ${airportDestination.name ||
      airportDestination.iata ||
      airportDestination} ?`}
  />
);

export default RemoveFlightLabel;



// WEBPACK FOOTER //
// ./src/component/RemoveFlightLabel.js